module.exports = __webpack_public_path__ + "static/media/video_consent_start_record_eng.35bad452.mp3";